import React from 'react'

export default function left(color, size) {
    return (<svg height={size} id="Layer_1" viewBox="0 0 512 512" width={size} xmlns="http://www.w3.org/2000/svg" data-name="back" >
        <polygon points="352,115.4 331.3,96 160,256 331.3,416 352,396.7 201.5,256 " stroke={color} />
    </svg>)
}